



























































import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import AppCheckRound from '@/components/AppCheckRound.vue'
import AppConfirmModal from '@/components/AppConfirmModal.vue'
import AppTitleBar from '@/components/AppTitleBar.vue'
import { CURRENT_USER } from '@/gql/auth'
import { MY_USER } from '@/gql/user'
import { Common } from '@/mixins'

@Component({
  components: {
    AppCheckRound,
    AppConfirmModal,
    AppTitleBar
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    },
    myUser: {
      query: MY_USER,
      skip () { return !this.currentUser },
      variables () { return { username: this.currentUser.username } }
    }
  }
})
export default class extends Mixins(Common) {
  myUser = { alba: { pepperPoint: 0 } }
  amount = 0
  checked = false
  isModalActive = false

  get tax () {
    return Math.ceil(this.amount * 0.033)
  }

  get isSubmitEnabled () {
    return this.checked && this.amount >= 1000 && this.amount <= this.myUser.alba.pepperPoint
  }

  async onClickSubmit () {
    await this.$apollo.mutate({
      mutation: gql`mutation ($input: RequestPepperPointUsageInput!) {
        requestPepperPointUsage(input: $input) {
          message
          user {
            id
            alba {
              id
              pepperPoint
            }
          }
        }
      }`,
      variables: {
        input: {
          usageType: 'CONVERT_TO_POINT',
          point: +this.amount
        }
      }
    })
    this.evictApolloCache('pepperPointHistoryConnection({})')
    this.isModalActive = true
  }
}
